// const AppLink= "http://192.168.0.103/AEC/PHP/";
// const ImageLink= "http://192.168.0.103/AEC/Upload/";
// const AppLink= "https://clients.jcecalender.com/PHP/";
// const ImageLink= "https://clients.jcecalender.com/Upload/";
const AppLink= "https://aecportal.com/PHP/";
const ImageLink= "https://aecportal.com/Upload/";
export default AppLink;
export {ImageLink};
